import { render, staticRenderFns } from "./summaryModels.vue?vue&type=template&id=3050746c&scoped=true"
import script from "./summaryModels.vue?vue&type=script&lang=js"
export * from "./summaryModels.vue?vue&type=script&lang=js"
import style0 from "./summaryModels.vue?vue&type=style&index=0&id=3050746c&prod&lang=scss"
import style1 from "./summaryModels.vue?vue&type=style&index=1&id=3050746c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3050746c",
  null
  
)

export default component.exports